import { Button } from './Button';

interface ModalFormActionsProps {
  onCancel: () => void;
  loading: boolean;
  disabled?: boolean;
  submitLabel: string;
  loadingLabel?: string;
}

export function ModalFormActions({ onCancel, loading, disabled = false, submitLabel, loadingLabel = 'Guardando...' }: Readonly<ModalFormActionsProps>) {
  return (
    <div className="flex gap-3 pt-4">
      <Button
        type="button"
        variant="secondary"
        onClick={onCancel}
        className="flex-1"
        disabled={loading}
      >
        Cancelar
      </Button>
      <Button
        type="submit"
        variant="primary"
        className="flex-1"
        disabled={loading || disabled}
      >
        {loading ? loadingLabel : submitLabel}
      </Button>
    </div>
  );
}
